/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_LoadingInputs */

const en_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading API Keys. Please wait...`)
};

const fr_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des clés API. Veuillez patienter...`)
};

const de_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel werden geladen. Bitte warten...`)
};

const it_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento delle chiavi API. Attendi...`)
};

const ru_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка ключей API. Пожалуйста, подождите...`)
};

const es_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando claves API. Espere...`)
};

const zh_cn2_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载 API 密钥。请稍候……`)
};

const ja_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーを読み込んでいます。お待ちください...`)
};

const hi_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी लोड हो रही हैं। कृपया प्रतीक्षा करें...`)
};

const pt_pt2_options_api_keys_loading = /** @type {(inputs: Options_Api_Keys_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando chaves de API. Aguarde...`)
};

/**
* | output |
* | --- |
* | "Loading API Keys. Please wait..." |
*
* @param {Options_Api_Keys_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_loading = /** @type {((inputs?: Options_Api_Keys_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_loading(inputs)
	if (locale === "de") return de_options_api_keys_loading(inputs)
	if (locale === "it") return it_options_api_keys_loading(inputs)
	if (locale === "ru") return ru_options_api_keys_loading(inputs)
	if (locale === "es") return es_options_api_keys_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_loading(inputs)
	if (locale === "ja") return ja_options_api_keys_loading(inputs)
	if (locale === "hi") return hi_options_api_keys_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_loading(inputs)
	return en_options_api_keys_loading(inputs)
});